<template>
  <el-card shadow="never">
    <span slot="header" style="font-weight: 600">次品</span>
    <Content :abnormal-type="abnormalDefective" abnormal="Client" uploadId="222" btnTitle="次品登记"
      @submitAbnormal="defectiveCall" ref="Client" :disabledChoose="disabledChoose" :record="record"></Content>
  </el-card>
</template>

<script>
import Content from "./Content";
import { abnormalDefective } from "@/types";
import { pkgSplit } from "@/apis/abnormal";
import { orderRemakeCount } from "@/apis/checking";

export default {
  name: "DefectiveSubmit",
  components: {
    Content,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
    disabledChoose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      abnormalDefective,
    };
  },
  methods: {
    defectiveCall: async function (val) {
      const that = this
      const toClient = await orderRemakeCount({ pkgCode: that.record.pkgCode })
      if (toClient.data > 0) {
        // if(true){
        that.$confirm(`此商品已重拍${toClient.data}次，为了降低客户次品率，请选择异常上报客户`, "提示", {
          confirmButtonText: "确定",
          type: "error",
          cancelButtonText: "继续登记次品",
          distinguishCancelAndClose: true
        }).then(() => {
          that.$emit('toClient')
        }).catch(action => {
          console.log(action)
          if (action == 'cancel') {
            continueSplit()
          }
        });
        return
      }
      continueSplit()
      function continueSplit() {
        // let childen = that.$refs.Client;
        console.log(val)
        const params = {
          pkgType: 2,
          exceptionCodeList: val.abnormal,
          picRelation: val.qrCode,
          pkgCode: that.record.pkgCode,
          amount: val.abnormalAmount,
          remark: val.textarea,
        };
        if (params.exceptionCodeList.length == 0) {
          that.$message.error("请勾选异常类型");
          return;
        }
        if (params.amount == 0 || !params.amount) {
          that.$message.error("入库数量必须大于0");
          return;
        }
        if (params.amount > that.record.amount) {
          that.$message.error("异常数量不能大于批次包数量");
          return;
        }
        pkgSplit(params).then(({ code }) => {
          if (code === 0) {
            that.$message.success("成功");
            that.$emit('DoStockIn')
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
